<script setup lang="ts">
import pages401 from "@images/pages/401.png";
import miscMaskDark from "@images/pages/misc-mask-dark.png";
import miscMaskLight from "@images/pages/misc-mask-light.png";

import { useGenerateImageVariant } from "@core/composable/useGenerateImageVariant";

definePage({
  alias: "/error/401",
  meta: {
    layout: "blank",
    public: true,
  },
});
const router = useRouter();
const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark);

function toLogin() {
  useCookie("accessToken").value = "";
  useCookie("userData").value = "";
  router.push("/login");
}
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader
      status-code="401"
      :title="$t('You are not authorized!') + ' 🔐'"
      :description="
        $t('You don’t have permission to access this page. Go Home!')
      "
    />

    <div class="d-flex justify-center">
      <VBtn class="mb-11" @click="$router.go(-2)"> {{ $t("Go Back") }} </VBtn>
      <VBtn class="mb-11 ml-3" @click="toLogin" color="default">
        {{ $t("Or Log In") }}
      </VBtn>
    </div>

    <!-- 👉 Image -->
    <div class="misc-avatar w-100 text-center">
      <VImg
        :src="pages401"
        alt="not autorized"
        :max-height="$vuetify.display.smAndDown ? 350 : 500"
        class="mx-auto"
      />
    </div>

    <img
      class="misc-footer-img d-none d-md-block"
      :src="authThemeMask"
      alt="misc-footer-img"
      height="320"
    />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
